import { InputAdornment, TextField } from "@mui/material";

interface RateInputProps {
  label: string;
  value: string;
  unit: string;
  onChange: (value: string) => void;
  error?: string;
  disabled?: boolean;
  fullWidth?: boolean;
}

export default function RateInput({ label, value, unit, onChange, error, disabled = false, fullWidth = false }: RateInputProps) {
  return (
    <TextField
      size="small"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      error={Boolean(error)}
      helperText={error}
      disabled={disabled}
      inputProps={{ inputMode: "decimal", "aria-label": label, style: { textAlign: "right" } }}
      InputProps={{
        startAdornment: <InputAdornment position="start">₹</InputAdornment>,
        endAdornment: <InputAdornment position="end">{`/ ${unit}`}</InputAdornment>,
      }}
      sx={{ width: fullWidth ? "100%" : 180, backgroundColor: "white" }}
    />
  );
}
